<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Lista de Filas </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select class="w-60 p-2 form-select form-select-lg mr-5 text-white font-medium btn--primary"
        aria-label=".form-select-lg" [formControl]="ordenarControl">
        <option disabled>Ordenar</option>
        <option *ngFor="let order of listOrder" [value]="order.value">{{ order.label }}</option>
      </select>

      <div>
        <input [formControl]="acaoInput" type="text" class="form-input w-64" placeholder="Pesquise por Nome" />
      </div>
      <div class="flex justify-between">
        <button (click)="filtrarFilas()" title="Filtrar Filas" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button (click)="limparFiltros()" title="Limpar Filas"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine">
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
        <button *isAllowed="[ERoleAdminString.Admin, 'queue.export']"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine" title="Download Excel Filas"
          (click)="downloadExcel()">
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div>
    </div>
  </div>

  <app-list-filas [filas]="filas" [dadosPaginacao]="dadosPaginacao" (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)" (recarregarListagem)="carregarFilas()"></app-list-filas>

  <hr class="mb-8" />

  <app-add-new-fila (recarregarListagem)="carregarFilas()"></app-add-new-fila>

  <hr class="my-8" *isAllowed="[ERoleAdminString.Admin, 'queue.create']" />
</form>